import type WorkflowFilterDefinitionModel from '@src/service/model/workflow/WorkflowFilterDefinitionModel'

import Repository from './base'

export const WORKFLOW_FILTER_DEFINITION_TABLE_NAME = 'workflowFilterDefinition'
export class WorkflowFilterDefinitionRepository extends Repository<WorkflowFilterDefinitionModel> {}
